import { useContext, useEffect } from 'react';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { LanguageContext } from '@/common/contexts/LanguageContext';
import { useTracking } from '@/common/contexts/TrackingContext';
import { trackVerifiedQuizPurchaseOnce } from '@/common/functions/trackVerifiedQuizPurchase';
import { ORDER_STATUS_PHASE } from '../constants/orderStatus.constants';
import useOrderStatusSuccessRedirect from '../hooks/useOrderStatusSuccessRedirect';
import {
	BrandMark,
	BrandRow,
	IconBadge,
	Message,
	RedirectNote,
	StatusCard,
	StatusPill,
	Title,
	VisualBlock,
} from '../orderStatusPage.styles';
import { CheckIcon } from './OrderStatusIcons';

const OrderStatusSuccess = ({ params }) => {
	const t = useLanguageData('chat');
	const { lang } = useContext(LanguageContext);
	const { trackFacebookEvent, trackTrafficJunkieEvent } = useTracking();

	useOrderStatusSuccessRedirect(params, ORDER_STATUS_PHASE.SUCCESS);

	useEffect(() => {
		if (!params.fromQuiz || params.isTokenPayment) {
			return;
		}

		trackVerifiedQuizPurchaseOnce({
			paymentIntent: params.paymentIntent,
			email: params.email,
			paymentFor: params.paymentFor,
			browsingPersonId: params.browsingPersonId,
			isPromo: params.isPromo,
			purchaseValue: params.purchaseValue,
			purchaseCurrency: params.purchaseCurrency,
			lang,
			trackFacebookEvent,
			trackTrafficJunkieEvent,
		});
	}, [params.fromQuiz, params.isTokenPayment]);

	return (
		<StatusCard $phase={ORDER_STATUS_PHASE.SUCCESS} aria-live='polite'>
			<BrandRow>
				<BrandMark>SoftAI</BrandMark>
				<StatusPill $phase={ORDER_STATUS_PHASE.SUCCESS}>
					{t.orderStatusPillSuccess}
				</StatusPill>
			</BrandRow>
			<VisualBlock>
				<IconBadge $phase={ORDER_STATUS_PHASE.SUCCESS} aria-hidden='true'>
					<CheckIcon />
				</IconBadge>
				<Title>
					{params.isTokenPayment
						? t.orderStatusTokensSuccess
						: t.orderStatusPaymentSuccess}
				</Title>
				<Message>
					{params.isTokenPayment
						? t.orderStatusTokensSuccessDescription
						: t.orderStatusPaymentSuccessDescription}
				</Message>
				<RedirectNote>{t.orderStatusRedirecting}</RedirectNote>
			</VisualBlock>
		</StatusCard>
	);
};

export default OrderStatusSuccess;
